"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTreeNode = exports.useTreeContext = exports.TreeProvider = void 0;

var react_1 = __importStar(require("react"));

var components_utils_1 = require("@conte-ltd/components-utils");

var TreeContext = (0, react_1.createContext)({});

function TreeProvider(_a) {
  var children = _a.children,
      currentState = _a.state,
      currentNode = _a.node,
      currentCollapsable = _a.collapsable,
      currentIsExclusive = _a.isExclusive;

  var _b = (0, react_1.useContext)(TreeContext),
      parentState = _b.state,
      parentNode = _b.node,
      parentCollapsable = _b.collapsable,
      parentIsExclusive = _b.isExclusive;

  var state = currentState !== null && currentState !== void 0 ? currentState : parentState;
  var node = currentNode !== null && currentNode !== void 0 ? currentNode : parentNode;
  var collapsable = currentCollapsable !== null && currentCollapsable !== void 0 ? currentCollapsable : parentCollapsable;
  var isExclusive = currentIsExclusive !== null && currentIsExclusive !== void 0 ? currentIsExclusive : parentIsExclusive;
  (0, components_utils_1.assertIsDefined)(state, 'TreeContextにstateが設定されていません');
  (0, components_utils_1.assertIsDefined)(node, 'TreeContextにnodeが設定されていません');

  var keys = __spreadArray([], __read(state.collection.getKeys()), false);

  var siblingKeys = (0, react_1.useMemo)(function () {
    return keys.map(function (key) {
      return state.collection.getItem(key);
    }).filter(function (item) {
      return item.parentKey === node.parentKey && item.key !== node.key;
    }).map(function (item) {
      return item.key;
    });
  }, [keys]);
  return react_1.default.createElement(TreeContext.Provider, {
    value: {
      state: state,
      node: node,
      collapsable: collapsable,
      isExclusive: isExclusive,
      siblingKeys: siblingKeys
    }
  }, children);
}

exports.TreeProvider = TreeProvider;

function useTreeContext() {
  var _a = (0, react_1.useContext)(TreeContext),
      state = _a.state,
      node = _a.node,
      other = __rest(_a, ["state", "node"]);

  (0, components_utils_1.assertIsDefined)(state, 'TreeContextにstateが設定されていません');
  (0, components_utils_1.assertIsDefined)(node, 'TreeContextにnodeが設定されていません');
  return __assign({
    state: state,
    node: node
  }, other);
}

exports.useTreeContext = useTreeContext;

function useTreeNode(_a) {
  var state = _a.state,
      node = _a.node,
      collapsable = _a.collapsable,
      isExclusive = _a.isExclusive,
      siblingKeys = _a.siblingKeys;

  if (!collapsable) {
    return {
      isExpanded: true
    };
  }

  var _b = __read((0, react_1.useState)(state.expandedKeys.has(node.key)), 2),
      isExpanded = _b[0],
      setIsExpand = _b[1];

  var onExpand = (0, react_1.useCallback)(function () {
    if (!state.expandedKeys.has(node.key)) {
      if (isExclusive) {
        siblingKeys === null || siblingKeys === void 0 ? void 0 : siblingKeys.forEach(function (key) {
          if (state.expandedKeys.has(key)) {
            state.toggleKey(key);
          }
        });
      }

      state.toggleKey(node.key);
    }
  }, [state, isExclusive]);
  var onCollapse = (0, react_1.useCallback)(function () {
    if (state.expandedKeys.has(node.key)) {
      state.toggleKey(node.key);
    }
  }, [state]);
  var onToggle = (0, react_1.useCallback)(function () {
    if (isExclusive) {
      siblingKeys === null || siblingKeys === void 0 ? void 0 : siblingKeys.forEach(function (key) {
        if (state.expandedKeys.has(key)) {
          state.toggleKey(key);
        }
      });
    }

    state.toggleKey(node.key);
  }, [state, isExclusive]);
  (0, react_1.useEffect)(function () {
    setIsExpand(state.expandedKeys.has(node.key));
  }, [state.expandedKeys]);
  return {
    isExpanded: isExpanded,
    onExpand: onExpand,
    onCollapse: onCollapse,
    onToggle: onToggle
  };
}

exports.useTreeNode = useTreeNode;